import {CircleAlert} from 'lucide-react';
import {Button} from '../ui/button';

export function ErrorState({onRetry}: {onRetry?: () => void}) {
    return (
        <div className="flex flex-col items-center justify-center">
            <CircleAlert className="w-16 h-16 text-primary-200" />
            <h1 className="text-3xl font-bold text-primary mt-4">Error</h1>
            <p className="text-lg text-gray-500">An error occurred.</p>
            {onRetry && (
                <Button color="primary" className="mt-6" onClick={onRetry}>
                    Retry
                </Button>
            )}
        </div>
    );
}

ErrorState.displayName = 'ErrorState';
